<template>
  <div
    class="container-fluid image-box"
    :style="getBlackForCSS"
    id="image-box"
    ref="imageBox"
    :class="{
      sticky: config.visualMode === 'conf',
      imageviewer: config.visualMode === 'images',
    }"
  >
    <div class="row" :style="getWhiteForCSS">
      <div
        :class="{ 'image-wide': $parent['showSideMenu'] === false }"
        :title="getImageTitle(set.currentItem)"
        class="col-12 image-list"
      >
        <div @scroll="switchCurrentItem()" id="image-list" class="no-scrollbar">
          <a
            v-if="
              ((set.currentItem !== 'set' && set.currentItem !== 'overview') ||
                (set.currentItem == 'overview' && this.isSetImageAvailable)) &&
              set.items.length > 2
            "
            @click="lastItem()"
            class="last-item-arrow"
            :class="{
              'hidden-md hidden-lg': config.visualMode !== 'images',
              'text-white': currentItemBg === blackColor,
              'text-black': currentItemBg !== blackColor,
              hidden:
                (set.items.length === 1 && !this.isSetImageAvailable) ||
                config.visualMode === 'conf',
            }"
          >
            <svg width="100%" height="100%" viewBox="0 0 400 100">
              <path
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                stroke="currentColor"
                d="M145.188,238.575l215.5-215.5c5.3-5.3,
                        5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225
                        c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"
              />
            </svg>
          </a>

          <span v-if="showAddonList" class="addon-list">
            <template v-for="(addonUrl, index) in addonList">
              <img
                v-if="index < 5"
                v-bind:key="'addon-' + index"
                :src="addonUrl"
                :alt="'addon ' + index"
                class="thumb"
                :class="'addon-thumb-' + index"
                @click="configure('stones', addonUrl)"
              />
            </template>
            <template v-if="isVariationSetPicture">
              <template v-if="addonList.length > 0">
                <br />
                <br />
                <br />
                <br v-if="config.visualMode === 'images'" />
              </template>
              <template
                v-for="(setId, index) in getSetIdOfVariations(set.currentItem)"
              >
                <a
                  v-bind:key="'set-thumb-' + index"
                  :href="
                    imageHost + '/sets/600/' + correctSetId(setId) + '.jpg'
                  "
                  target="_blank"
                >
                  <img
                    v-if="index < 5"
                    :src="
                      imageHost + '/sets/600/' + correctSetId(setId) + '.jpg'
                    "
                    :alt="'addon-' + setId"
                    class="set-thumb"
                    :class="'set-thumb-' + index"
                  />
                </a>
              </template>
            </template>
          </span>

          <div
            id="BrandLogo"
            class="col-12"
            :style="!isBrandLogo ? 'visibility: hidden' : ''"
          >
            <img :src="getBrandLogoSrc" />
          </div>

          <ul
            :style="{
              width:
                100 *
                  (set.items.length +
                    (isSetImageAvailable && set.items.length > 1
                      ? 3
                      : set.items.length === 1
                      ? 0
                      : 2)) +
                '%',
            }"
            :class="{
              'vm-images': config.visualMode === 'images',
              'vm-conf': config.visualMode === 'conf',
              'vm-show': config.visualMode === 'show',
              'without-side-menu': config.showSideMenu === false,
              'is-order-overview': $parent['showSideMenu'],
              'is-set': set.currentItem === 'set',
              'has-item-mix': hasItemTypesMix,
              'is-not-3d': !is3dViewerActive,
              'is-variation':
                (config.visualMode !== 'images' &&
                  !isNaN(set.currentItem) &&
                  $parent['getSetIdOfVariations'](set.currentItem).length >
                    0) ||
                (isNaN(set.currentItem) && $parent['isVariationInSet']),
              'is-jewellery':
                config.visualMode !== 'images' &&
                !isNaN(set.currentItem) &&
                $parent['isCurrentItemJewellery'](set.currentItem),
              'is-weddingring':
                config.visualMode !== 'images' &&
                ((!isNaN(set.currentItem) &&
                  $parent['isCurrentItemWeddingRing'](set.currentItem)) ||
                  $parent['onlyWeddingRings']()),
              'is-basic-model':
                config.visualMode !== 'images' &&
                !isNaN(set.currentItem) &&
                $parent['isCurrentItemBasicModel'](set.currentItem),
              'is-overview':
                set.currentItem === 'overview' || set.currentItem === 'all',
            }"
          >
            <li
              id="itemImage-set"
              :style="{ width: liElementWidth }"
              v-if="isSetImageAvailable"
            >
              <img
                :src="
                  imageHost + '/sets/600/' + correctSetId(set.setId) + '.jpg'
                "
                @click="toggleImageView(false)"
                :ref="'itemImageSet'"
                @error="
                  $refs['itemImageSet'].src =
                    appUrl + '/img/assets/placeholder600.svg'
                "
                :class="{
                  hidden:
                    $parent.$parent['hideImage'] &&
                    $parent.$parent['hideImage'].set === true,
                }"
                data-item="set"
                alt="Set"
              />
            </li>
            <li
              id="itemImage-overview"
              :style="{ width: liElementWidth }"
              :class="{
                'crop-set-img': set.items.length === 2,
                'image-bdcolor':
                  onlyWeddingRings &&
                  !onlyBasicModels &&
                  !hasItemTypesMix &&
                  is3dViewerActive === false,
                'number-items-4': set.items.length >= 4,
              }"
            >
              <div
                :class="{
                  hidden:
                    is3dViewerActive && hideItemImage('overview') === true,
                }"
                style="display: inline"
              >
                <SetImageThumbs
                  @click="toggleImageView(false)"
                  v-if="hasItemTypesMix || onlyBasicModels"
                  :items="set.items"
                  :getApiHost="getApiHost"
                  :onlyBasicModel="onlyBasicModels"
                />
                <img
                  v-else
                  @click="toggleImageView(false)"
                  :ref="'itemImageOverview'"
                  @error="
                    $refs['itemImageOverview']
                      ? ($refs['itemImageOverview'].src =
                          appUrl + '/img/assets/placeholder600.svg')
                      : ''
                  "
                  :src="getSrc(set.items, null, null)"
                  data-item="overview"
                  alt="Set"
                />
                <p
                  v-if="!onlyJewellery && !onlyBasicModels"
                  class="variation-notification text-center"
                  :class="config.visualMode + ' ' + set.currentItem"
                >
                  <template
                    v-if="isVariationInSet && set.currentItem !== 'set'"
                  >
                    <p>{{ $t("Notifications.variations") }}</p>
                  </template>
                  <template v-else><p class="no-border">&nbsp;</p></template>
                </p>
              </div>
              <SetImageViewer3d
                v-if="
                  is3dViewerActive &&
                  (hideItemImage('overview') === true || set.items.length < 2)
                "
                :items="set.items"
              ></SetImageViewer3d>
            </li>
            <template v-if="set.items.length > 1">
              <li
                v-for="(item, index) in set.items"
                v-bind:key="index"
                :style="{ width: liElementWidth }"
                :class="{
                  'image-bdcolor':
                    parseInt(item.description.jewelleryType) === 0 &&
                    !item.description.isBasicModel &&
                    is3dViewerActive === false,
                  hidden: set.items.length === 1,
                }"
              >
                <div
                  :class="{
                    hidden: is3dViewerActive && hideItemImage(index) === true,
                  }"
                  style="display: inline"
                >
                  <img
                    class="item-pic"
                    @click="toggleImageView(false)"
                    :ref="'itemImage' + index"
                    @error="
                      $refs['itemImage' + index][0].src =
                        appUrl + '/img/assets/placeholder600.svg'
                    "
                    :src="
                      getSrc(
                        [set.items[index]],
                        item.description.jewelleryType,
                        item.description.isBasicModel
                      )
                    "
                    :data-item="index"
                    :id="'itemImage-' + index"
                    :alt="item.itemnumber.toUpperCase()"
                  />
                  <p
                    v-if="!onlyJewellery && !onlyBasicModels"
                    class="variation-notification text-center"
                    :class="config.visualMode + ' ' + set.currentItem"
                  >
                    <template
                      v-if="
                        item.description.isVariation &&
                        item.description.jewelleryType < 1 &&
                        set.currentItem !== 'set'
                      "
                    >
                      <p>{{ $t("Notifications.variations") }}</p>
                    </template>
                    <template v-else><p class="no-border">&nbsp;</p></template>
                  </p>
                </div>
                <SetImageViewer3d
                  v-if="is3dViewerActive && hideItemImage(index) === true"
                  :items="set.items"
                ></SetImageViewer3d>
              </li>
            </template>
            <li
              :style="{ width: liElementWidth }"
              id="itemImage-all"
              :class="{
                'crop-set-img': set.items.length === 2,
                'image-bdcolor':
                  onlyWeddingRings &&
                  !onlyBasicModels &&
                  !hasItemTypesMix &&
                  is3dViewerActive === false,
                hidden: set.items.length === 1 || set.items.length >= 4,
                'number-items-4': set.items.length === 4,
              }"
            >
              <div
                :class="{
                  hidden: is3dViewerActive && hideItemImage('all') === true,
                }"
                style="display: inline"
              >
                <SetImageThumbs
                  @click="toggleImageView(false)"
                  v-if="hasItemTypesMix"
                  :items="set.items"
                  :getApiHost="getApiHost"
                  :onlyBasicModel="onlyBasicModels"
                />
                <img
                  v-else
                  @click="toggleImageView(false)"
                  :ref="'itemImageAll'"
                  @error="
                    $refs['itemImageAll']
                      ? ($refs['itemImageAll'].src =
                          appUrl + '/img/assets/placeholder600.svg')
                      : null
                  "
                  :src="getSrc(set.items, null, null)"
                  data-item="all"
                  alt="Set"
                />
                <p
                  v-if="!onlyJewellery && !onlyBasicModels"
                  class="variation-notification text-center"
                  :class="config.visualMode + ' ' + set.currentItem"
                >
                  <template
                    v-if="isVariationInSet && set.currentItem !== 'set'"
                  >
                    <p>{{ $t("Notifications.variations") }}</p>
                  </template>
                  <template v-else><p class="no-border">&nbsp;</p></template>
                </p>
              </div>
              <SetImageViewer3d
                v-if="is3dViewerActive && hideItemImage('all') === true"
                :items="set.items"
              ></SetImageViewer3d>
            </li>
          </ul>

          <a
            v-if="
              ((set.currentItem !== 'all' && set.items.length < 4) ||
                (set.items.length === 4 && set.currentItem !== 3)) &&
              set.items.length > 2
            "
            @click="nextItem()"
            class="next-item-arrow"
            :class="{
              'hidden-md hidden-lg': config.visualMode !== 'images',
              'text-white': currentItemBg === blackColor,
              'text-black': currentItemBg !== blackColor,
              hidden: set.items.length === 1 || config.visualMode === 'conf',
            }"
          >
            <svg width="100%" height="100%" viewBox="0 0 400 100">
              <path
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                stroke="currentColor"
                d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,
                              19.1l215.5,215.5l-215.5,215.5   c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,
                              4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,
                              360.731,229.075z   "
              />
            </svg>
          </a>

          <div id="flag-icons" v-if="isCampaignWeddingRings">
            <div class="flag-icon-box">
              <i class="icon-flag icon-campaign-discount rounded text-center">
                {{ $t("Set.Overview.campaign.discount") }}
              </i>
            </div>
          </div>

          <svg
            v-if="showWishlistIcon"
            width="100%"
            height="100%"
            viewBox="0 0 114.43 99.9"
            class="heart"
            @click="toggleToWishlist()"
            :class="{
              'text-white': currentItemBg === blackColor,
              'text-black': currentItemBg !== blackColor,
            }"
          >
            <path
              stroke-width="4px"
              :stroke="heartStroke"
              :fill="heartBg"
              d="M83.57,2A28.93,28.93,0,0,0,57.22,19.06,28.87,28.87,0,0,0,2,30.88c0,35.9,51.79,65.46,54,66.7a2.49,2.49,0,0,0,1.21.32,2.46,2.46,0,0,0,1.21-.32c2.2-1.24,54-30.8,54-66.7A28.89,28.89,0,0,0,83.57,2Z"
            />
          </svg>
          <!--
          <div
            v-if="showMagnifierIcon"
            @click="toggleImageView(false)"
            class="magnifer d-none d-xl-block"
            :class="{
              'text-white': currentItemBg === blackColor,
              'text-black': currentItemBg !== blackColor,
            }"
          >
            <MagnifierMinus v-if="mode === 'full'" />
            <MagnifierPlus v-else />
          </div>
          -->
          <div v-if="isVisualModeIcon && viewer3dAllowed" class="visual-mode">
            <Icon3d
              v-if="show3dIcon"
              :set="set"
              :visualMode="config.visualMode"
              :isAddonList="addonList.length > 0"
              :isNumberItems4="set.items.length === 4"
              :isOverview="
                (set.currentItem === 'overview' || set.currentItem === 'all') &&
                config.visualMode === 'show'
              "
              :isSetIcon="isVariationSetPicture"
            />
            <Icon2d
              v-else-if="show3dIcon === false && show2dIcon === true"
              :set="set"
              :visualMode="config.visualMode"
              :isNumberItems4="set.items.length === 4"
              :isAddonList="addonList.length > 0"
              :isOverview="
                (set.currentItem === 'overview' || set.currentItem === 'all') &&
                config.visualMode === 'show'
              "
              :isSetIcon="isVariationSetPicture"
            />
          </div>
        </div>

        <SetImageJewelleryPics
          v-if="isJewelleryPics && !is3dViewerActive"
          :items="set.items"
          :currentItem="set.currentItem"
        />

        <div
          id="ShowPicture"
          :class="{
            hidden:
              showPictureSrc == '' ||
              (config.visualMode === 'conf' && !isDesktop()),
          }"
        >
          <a
            @click="closePicture"
            type="button"
            aria-label="Close"
            class="close"
          >
            <img
              :src="appUrl + '/img/icons/close.svg'"
              class="icon"
              alt="close"
            />
          </a>
          <img
            id="ShowPictureResult"
            ref="ShowPictureResult"
            @click="openPicture()"
            :width="showPictureWidth"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Status from "@/vuex/Status";
import SetData from "@/vuex/SetData";
import DAOWishlist from "../../../public/js/DAO/Wishlist";
import Config from "@/vuex/Config";
import Wishlist from "@/assets/Wishlist";
import MediaQuery from "@/assets/Helper/MediaQuery";
import JewelleryViewer3d from "@/assets/DAO/JewelleryViewer3d";

//import MagnifierMinus from "@/components/Icons/MagnifierMinus";
//import MagnifierPlus from "@/components/Icons/MagnifierPlus";
import Icon2d from "@/components/Icons/Icon2d.vue";
import Icon3d from "@/components/Icons/Icon3d.vue";
import SetImageThumbs from "@/components/Set/Image/Thumbs";
import SetImageJewelleryPics from "@/components/Set/Image/JewelleryPics";
import SetImageViewer3d from "@/components/Set/Image/Viewer3d";
import Logger from "@/assets/Helper/Logger";

export default {
  name: "SetImage",
  components: {
    //MagnifierMinus,
    //MagnifierPlus,
    Icon2d,
    Icon3d,
    SetImageThumbs,
    SetImageJewelleryPics,
    SetImageViewer3d,
  },
  data() {
    return {
      appUrl: Config.getters.getAppUrl,
      config: Config.getters.getConfig,
      imageHost: process.env.VUE_APP_IMAGE_HOST,
      showSetIn3d: SetData.getters.getShowSetIn3d,
      currentSet3d: false,
      lastScrollY: 0,
      show3dIcon: true,
      show2dIcon: true,
      viewer3dAllowed: true,
      showWishlistIcon: true,
      showMagnifierIcon: true,
      showAddonList: true,
      isOnWishlist: false,
      blackColor: "000000",
      whiteColor: "ffffff",
      lightGreyColor: "f5f5f5",
      currentItemBg: "",
      showPictureSrc: "",
      showPictureWidth: "100%",
      campaigns:
          typeof window.conf2020AppConfig.campaigns === "object"
              ? window.conf2020AppConfig.campaigns
              : { weddingbands: "no", jewellery: "no", priceDrop: "no" },
    };
  },
  props: ["getApiHost", "set", "mode"],
  mounted() {
    this.$root.$on("setHeartWishlistOn", () => {
      this.isOnWishlist = true;
    });
    this.$root.$on("setHeartWishlistOff", () => {
      this.isOnWishlist = false;
    });
    this.$root.$on("checkWishlistIcon", () => {
      this.checkWishlist();
    });

    let node = document.getElementById("itemImage-" + this.set.currentItem);
    this.setCurrentItemBg();
    if (node !== null && this.config.visualMode === "images") {
      //node.scrollIntoView();
    }
    this.$root.$on("showPicture", (imgSrc) => {
      this.closePicture();

      imgSrc = imgSrc.target.attributes[1].nodeValue;

      this.showPictureWidth = "100%";

      if (imgSrc.indexOf("/inside/") > -1 || imgSrc.indexOf("/outside/") > -1) {
        imgSrc = imgSrc.replace("/false/", "/true/");
        this.showPictureWidth = "";
      }

      this.showPicture(imgSrc);
    });

    if (this.config.visualMode !== "images" && Status.state.isInit === true) {
      let currentItem = this.set.currentItem;
      if (
        (this.set.setId === "" && isNaN(currentItem)) ||
        this.set.items.length < 2
      ) {
        currentItem = "overview";
      }
      this.$parent.$parent["setCurrentItem"](currentItem);
    }

    this.show3dIcon =
      this.$parent.$parent["hideImage"][
        this.set.items.length < 2 ? "overview" : this.set.currentItem
      ] !== true;

    window.addEventListener("resize", this.resize);
    /*
    window.addEventListener("scroll", this.scroll.bind(this), {
      capture: true,
      passive: true,
    });
    */
  },
  updated() {
    this.show3dIcon =
      this.$parent.$parent["hideImage"][
        this.set.items.length < 2 ? "overview" : this.set.currentItem
      ] !== true;

    let Viewer3d = this.$parent.$parent["Viewer3d"];
    if (this.config.visualMode === "images") {
      if (Viewer3d) {
        setTimeout(() => {
          if (Viewer3d["isTryOnStarted"]()) {
            this.show2dIcon = false;
            this.showWishlistIcon = false;
            this.showAddonList = false;
            this.showMagnifierIcon = false;
          }
        });
      }
    }

    let tmpSetId = "";
    if (
      this.set.items[this.set.currentItem] &&
      this.set.items[this.set.currentItem].description.jewelleryType > 0
    ) {
      tmpSetId = this.set.items[this.set.currentItem].description.setId;
    }

    Viewer3d =
      this.currentSet3d !== false && tmpSetId !== ""
        ? this.$parent.$parent["Viewer3dSet"]
        : this.$parent.$parent["Viewer3d"];
    if (Viewer3d) {
      const viewerControls = document.getElementById("jewelleryViewerControls");
      if (viewerControls) {
        Viewer3d["resetRotate"]();
      } else {
        Viewer3d["stopRotate"]();
      }
    }

    this.viewer3dAllowed = this.is3dViewerAllowed();
    if (this.viewer3dAllowed === false) {
      this.$parent.$parent["hideImage"][this.set.currentItem] = false;
    } else {
      /* Visual-Mode-Icon for Jewellery -> check for 3D model file */
      this.getVisualModeIconVariation();
    }
  },
  beforeDestroy() {
    this.$root.$off("setHeartWishlistOn");
    this.$root.$off("setHeartWishlistOff");
    this.$root.$off("checkWishlistIcon");
  },
  destroyed() {
    window.removeEventListener("resize", this.resize);
    //window.removeEventListener("scroll", this.scroll);
  },
  watch: {
    set: {
      handler: function () {
        this.checkWishlist();
        this.setCurrentItemBg();
        this.setHasItemTypeMix();
        this.setIsVariationInSet();
      },
      deep: true,
    },
  },
  methods: {
    getScrollTop: function () {
      return (
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0
      );
    },
    scroll: function () {
      if (!MediaQuery.isDesktop()) {
        const visualModeContainer = document.querySelector(".image-col-right");
        if (visualModeContainer) {
          const containerDimensions =
            visualModeContainer.getBoundingClientRect();
          if (containerDimensions && containerDimensions.top > 0) {
            const imageBox = this.$refs.imageBox;
            if (this.getScrollTop() >= containerDimensions.top + 250) {
              imageBox.classList.add("fixed");
            } else {
              imageBox.classList.remove("fixed");
            }
          }
        }
      }
    },
    resize: function () {
      if (this.windowWidth !== window.innerWidth) {
        // Bug-Fix Safari -> Scrolling triggers resize
        this.windowWidth = window.innerWidth;

        this.setOverviewImage();
      }
    },
    setOverviewImage: function () {
      if (this.$refs.itemImageOverview) {
        let overviewImageSrc = this.$refs.itemImageOverview.getAttribute("src");
        const originalImgSrc = overviewImageSrc;
        if (MediaQuery.isDesktop()) {
          if (overviewImageSrc.indexOf("/600/600/1/") > -1) {
            overviewImageSrc = overviewImageSrc.replace(
              "/600/600/1/",
              "/600/600/"
            );
          }
        } else {
          if (overviewImageSrc.indexOf("/600/600/1/") === -1) {
            overviewImageSrc = overviewImageSrc.replace(
              "/600/600/",
              "/600/600/1/"
            );
          }
        }
        if (overviewImageSrc !== originalImgSrc) {
          this.$refs.itemImageOverview.setAttribute("src", overviewImageSrc);
        }
      }
    },
    getImageTitle: function (currentItemId) {
      if (
        this.$parent.$parent["Viewer3d"] &&
        this.$parent.$parent["Viewer3d"]["isTryOnStarted"]()
      ) {
        return false;
      }

      let title = "";

      if (typeof this.set.items[currentItemId] === "object") {
        title = this.getImageTitleString(
          this.set.items[currentItemId],
          currentItemId
        );
      } else {
        for (let itemIdx in this.set.items) {
          title += this.getImageTitleString(this.set.items[itemIdx], itemIdx);

          if (parseInt(itemIdx) + 1 !== this.set.items.length) {
            title += "\n\n";
          }
        }
      }

      return title;
    },
    getImageTitleString: function (item, currentItemId) {
      let name =
        item.name != ""
          ? item.name
          : this.$t("Set.Item.Description.name.placeholder") +
            " " +
            (parseInt(currentItemId) + 1);

      let title =
        this.$t("Set.Item.Description.name.title") + ": " + name + "\n";
      title += this.$t("Set.Item.Description.ringsize") + ": ";

      if (item.description.jewelleryType == 5) {
        title += item.description.stones.diamondStock.description;
      } else {
        title += item.size;
      }

      if (item.description.jewelleryType < 1) {
        title +=
          "\n" +
          this.$t("Set.Item.Description.width") +
          ", " +
          this.$t("Set.Item.Description.height") +
          ": " +
          item.description.width +
          " mm - " +
          item.description.height +
          " mm\n";
        title +=
          this.$t("Set.Item.Description.profile") +
          ": " +
          item.description.profile;
      }

      return title;
    },
    getSetIdOfVariations: function (currentItemId) {
      let setIds = [];
      let checkSet = {};
      if (typeof this.set.items[currentItemId] === "object") {
        if (
          typeof this.set.items[currentItemId].description === "object" &&
          this.set.items[currentItemId].description.isVariation &&
          this.set.items[currentItemId].description.jewelleryType < 1
        ) {
          setIds.push(this.set.items[currentItemId].description.setId);
        }
      } else {
        for (let itemIdx in this.set.items) {
          if (
            typeof this.set.items[itemIdx].description === "object" &&
            this.set.items[itemIdx].description.isVariation &&
            this.set.items[itemIdx].description.jewelleryType < 1
          ) {
            let tmpSetId = this.set.items[itemIdx].description.setId;

            if (!checkSet[tmpSetId]) {
              setIds.push(tmpSetId);
              checkSet[tmpSetId] = true;
            }
          }
        }
      }
      return setIds;
    },
    setHasItemTypeMix: function () {
      this.$parent["hasItemTypeMix"] = this.hasItemTypesMix;
    },
    setIsVariationInSet: function () {
      this.$parent["isVariationInSet"] = this.isVariationInSet;
    },
    getSrc: function (items, jewelleryType, isBasicModel) {
      let imgSrc = "";

      if (typeof items[0] === "object") {
        if (jewelleryType != 5) {
          let background = "";
          if (jewelleryType === null && isBasicModel === null) {
            background =
              this.onlyWeddingRings && !this.onlyBasicModels
                ? this.imageBgColor
                : this.whiteColor;
          } else {
            background =
              jewelleryType > 0 || isBasicModel === true
                ? this.whiteColor
                : this.imageBgColor;
          }

          let itemStr = items
            .map((a) => a.itemnumber)
            .join("_")
            .toUpperCase();
          if (isNaN(this.set.currentItem) && this.onlyBasicModels) {
            itemStr = items[0].itemnumber.toUpperCase();
          }

          if (this.isDesktop() || items.length !== 2) {
            imgSrc =
              this.getApiHost +
              "/v2/images/item/" +
              background +
              "/600/600/" +
              itemStr +
              ".jpg";
          } else {
            imgSrc =
              this.getApiHost +
              "/v2/images/item/" +
              background +
              "/600/600/1/" +
              itemStr +
              ".jpg";
          }
        } else {
          imgSrc =
            this.appUrl +
            "/img/assets/stones/exchange/stone_" +
            items[0].description.stones.diamondStock.stoneform.toLowerCase() +
            ".jpg";
        }
      }

      return imgSrc;
    },
    hideItemImage: function (index) {
      return this.$parent.$parent["hideImage"][index];
    },
    showPicture: function (imgSrc) {
      if (typeof imgSrc == "string" && this.$refs.ShowPictureResult) {
        this.$refs.ShowPictureResult.src = imgSrc;
        this.showPictureSrc = imgSrc;
      }
    },
    closePicture: function () {
      this.showPictureSrc = "";
    },
    openPicture: function () {
      if (this.isDesktop()) {
        this.$parent.$parent.openPicture(this.$refs.ShowPictureResult.src);
      } else {
        this.showPictureSrc = "";
      }
    },
    isCurrentItemDiamond: function () {
      let currentItem = SetData.getters.getCurrentItem;
      if (
        currentItem &&
        currentItem.description &&
        currentItem.description.jewelleryType == 5
      ) {
        return true;
      }
      return false;
    },
    configure: function (type, imgSrc) {
      if (type === "stones" && this.config.visualMode === "images") {
        this.$parent.$parent.openPicture(imgSrc);
      } else {
        Config.dispatch("setVisualMode", "show").then(() => {
          Config.dispatch("setCurrentVarType", type).then(() =>
            this.$root.$emit("hideLoader3D")
          );
        });
      }
    },
    toggleImageView: function (/*isTryOn*/) {
      return false;
      /*
      let currentItemId = SetData.getters.getCurrentItemId;
      if (this.config.visualMode === "images" || !MediaQuery.isDesktop()) {
        Config.dispatch("setVisualMode", "conf").then(() => {
          if (
            this.isCurrentItemDiamond() ||
            Config.getters.getcurrentVarType == "" ||
            currentItemId === "all"
          ) {
            Config.dispatch("setVisualMode", "show").then(() => {
              this.$root.$emit("hideLoader3D");
            });
            this.$root.$emit("setOverview");
          }

          setTimeout(() => {
            this.$parent.$parent["setCurrentItem"](currentItemId);
            this.$root.$emit("configure");
          }, 500);

          this.$root.$emit("hideLoader3D");
        });
      } else {
        Config.dispatch("setVisualMode", "images").then(() => {
          if (parseInt(currentItemId) > -1 && isTryOn) {
            if (
              this.set.items[this.set.currentItem] &&
              this.set.items[this.set.currentItem].description.jewelleryType > 0
            ) {
              this.$parent.$parent["Viewer3dSet"]["startTryOn"]();
            } else {
              this.$parent.$parent["Viewer3d"]["startTryOn"]();
            }
          }

          this.$root.$emit("hideLoader3D");
        });
      }
      */
    },
    checkWishlist: function () {
      let wishlistData = SetData.getters.getWishlistItemData;
      DAOWishlist.getItemId("wishlist", wishlistData).then((wishlistItemId) => {
        this.isOnWishlist = !(wishlistItemId === false);

        if (this.isOnWishlist === true) {
          this.$root.$emit("setBtnWishlistOn");
        } else {
          this.$root.$emit("setBtnWishlistOff");
        }
      });
    },
    toggleToWishlist: function () {
      let wishlistData = SetData.getters.getWishlistItemData;

      Wishlist.toggleWishlist(wishlistData).then((result) => {
        this.isOnWishlist = result;

        if (result == true) {
          this.$root.$emit("setBtnWishlistOn");
        } else {
          this.$root.$emit("setBtnWishlistOff");
        }
      });
    },
    lastItem: function () {
      let lastItem;
      if (this.set.currentItem === "all") {
        lastItem = this.set.items.length - 1;
      } else if (this.set.currentItem === "overview" && this.isValidSetId()) {
        lastItem = "set";
      } else if (this.set.currentItem === 0) {
        lastItem = "overview";
      } else {
        lastItem = this.set.currentItem - 1;
      }

      this.$parent.$parent["setCurrentItem"](lastItem);

      if (
        Config.getters.getcurrentVarType !== "" &&
        Config.getters.getConfig.visualMode === "conf"
      ) {
        this.$root.$emit("configure");
      }
    },
    nextItem: function () {
      let nextItem;

      if (this.isValidSetId() && this.set.currentItem === "set") {
        nextItem = "overview";
      } else if (this.set.currentItem === "overview") {
        nextItem = 0;
      } else {
        nextItem = this.set.currentItem + 1;

        if (nextItem >= this.set.items.length) {
          nextItem = "all";
        }
      }

      this.$parent.$parent["setCurrentItem"](nextItem);

      if (
        Config.getters.getcurrentVarType !== "" &&
        Config.getters.getConfig.visualMode === "conf"
      ) {
        this.$root.$emit("configure");
      }
    },
    setCurrentItem: function (newCurrentItem) {
      if (Config.getters.getConfig.visualMode === "show") {
        this.$root.$emit("toggleMenu");
      } else {
        this.$parent.$parent["setCurrentItem"](newCurrentItem);

        Config.dispatch("setVisualMode", "show");
      }
    },
    setCurrentItemBg: function () {
      if (this.is3dViewerActive) {
        this.currentItemBg = this.whiteColor;
      } else {
        if (
          ((this.set.currentItem === "overview" ||
            this.set.currentItem === "all" ||
            (this.set.currentItem === "set" && !this.isValidSetId())) &&
            this.onlyWeddingRings &&
            !this.onlyBasicModels) ||
          (typeof this.set.items[this.set.currentItem] === "object" &&
            parseInt(
              this.set.items[this.set.currentItem].description.jewelleryType
            ) === 0 &&
            !this.set.items[this.set.currentItem].description.isBasicModel)
        ) {
          this.currentItemBg = this.imageBgColor;
        } else {
          this.currentItemBg = this.whiteColor;
        }
      }
    },
    switchCurrentItem: function () {
      /**
       * Erkennung des Artikels durch scroll'n ist auf dem Desktop deaktiviert.
       */
      let node = document.getElementById("image-list");

      if (node && this.lastScrollY !== node.scrollLeft) {
        this.lastScrollY = node.scrollLeft;
        let SelfClass = this;

        setTimeout(
          (lastScrollY, set) => {
            let node = document.getElementById("image-list");
            if (node && lastScrollY === node.scrollLeft) {
              let liNodes = node.getElementsByTagName("li");

              let liNodeWidth = liNodes[0].offsetWidth;

              let pos = Math.round(node.scrollLeft / liNodeWidth);

              let newCurrentItem = pos - (SelfClass.isValidSetId() ? 2 : 1);

              if (pos === 0) {
                newCurrentItem = SelfClass.isValidSetId() ? "set" : "overview";
              } else if (pos === 1 && SelfClass.isValidSetId()) {
                newCurrentItem = "overview";
              } else if (
                pos >
                set.items.length + (SelfClass.isValidSetId() ? 1 : 0)
              ) {
                newCurrentItem = "all";
              }

              if (
                (newCurrentItem == "all" ||
                  this.$parent.$parent["isInMenuList"](newCurrentItem) ===
                    false) &&
                this.config.visualMode !== "images"
              ) {
                Config.dispatch("setVisualMode", "show");
              }

              if (newCurrentItem !== set.currentItem) {
                this.$parent.$parent["setCurrentItem"](newCurrentItem);

                SelfClass.setCurrentItemBg();
                if (
                  Config.getters.getcurrentVarType !== "" &&
                  Config.getters.getConfig.visualMode === "conf"
                ) {
                  if (this.set.items[newCurrentItem]) {
                    let jewelleryType = parseInt(
                      this.set.items[newCurrentItem].description.jewelleryType
                    );
                    if (
                      jewelleryType === 0 &&
                      Config.getters.getcurrentVarType ===
                        "stones/jewellery/normal"
                    ) {
                      Config.dispatch("setCurrentVarType", "jewellery/stones");
                    } else if (
                      jewelleryType > 0 &&
                      Config.getters.getcurrentVarType === "jewellery/stones"
                    ) {
                      Config.dispatch(
                        "setCurrentVarType",
                        "stones/jewellery/normal"
                      );
                    }
                  }
                  SelfClass.$root.$emit("configure");
                }
              }
            }
          },
          100,
          this.lastScrollY,
          this.set
        );
      }
    },
    isValidSetId: function () {
      return this.set.showSetImage === true;
    },
    isDesktop() {
      return MediaQuery.isDesktop();
    },
    correctSetId: function (setId) {
      if (typeof this.$parent.$parent["correctSetId"] === "function") {
        return this.$parent.$parent["correctSetId"](setId);
      }
      return setId.toLowerCase();
    },
    is3dViewerAllowed: function () {
      let items3d = this.set.items;
      if (!isNaN(this.set.currentItem)) {
        items3d = [this.set.items[this.set.currentItem]];
      }

      for (let itemIdx in items3d) {
        if (
          items3d[itemIdx] &&
          items3d[itemIdx].description &&
          items3d[itemIdx].description.possibleVariations &&
          items3d[itemIdx].description.possibleVariations["3dViewer"] !== true
        ) {
          return false;
        }
      }
      return true;
    },
    isVariation: function () {
      if (
        this.set.items[this.set.currentItem] &&
        this.set.items[this.set.currentItem].description &&
        this.set.items[this.set.currentItem].description.isVariation &&
        this.set.items[this.set.currentItem].description.jewelleryType < 1
      ) {
        return true;
      }
      return false;
    },
    getVisualModeIconVariation: async function () {
      let tmpSetId = "";
      if (isNaN(this.set.currentItem)) {
        return false;
      } else {
        tmpSetId = this.set.items[this.set.currentItem].description["setId"];
        if (!tmpSetId) {
          return false;
        } else {
          this.showSetIn3d[tmpSetId] = this.showSetIn3d[tmpSetId] ?? null;
        }
      }

      if (
        this.set.items[this.set.currentItem] &&
        this.set.items[this.set.currentItem].description["jewelleryType"] > 0 &&
        this.showSetIn3d[tmpSetId] == null
      ) {
        await JewelleryViewer3d.getSet(tmpSetId, "").then((response) => {
          this.currentSet3d =
            response["isJewelleryViewer"] === true ? tmpSetId : false;

          this.showSetIn3d[tmpSetId] = response["isJewelleryViewer"];

          let payload3d = {};
          payload3d[tmpSetId] = response["isJewelleryViewer"];

          SetData.dispatch(
            "setShowSetIn3d",
            Object.assign(this.showSetIn3d, payload3d)
          ).catch((error) => {
            Logger.error(error);
          });
        });
      }
      this.currentSet3d = this.showSetIn3d[tmpSetId] ? tmpSetId : false;
    },
    isJewelleryBut3dConfigurator: function () {
      if (
        this.set.items[this.set.currentItem] &&
        ((this.set.items[this.set.currentItem].description["jewelleryType"] ===
          11 &&
          this.set.items[this.set.currentItem].description["brandId"] === 35) ||
          (this.set.items[this.set.currentItem].description["jewelleryType"] ===
            11 &&
            this.set.items[this.set.currentItem].description["plineId"] ===
              563))
      ) {
        return true;
      }
      return false;
    },
  },
  computed: {
    isCampaignWeddingRings: function() {
      let count = 0;
      for (let itemIdx in this.set.items) {
        if (
            this.campaigns.weddingbands === "yes" &&
            !this.set.items[itemIdx].hasItemTypeMix &&
            this.set.items[itemIdx].description.jewelleryType < 1
        ) {
          count++;
        }
      }

      if (count === this.set.items.length) {
        return true;
      }

      return false;
    },
    is3dViewerActive: function () {
      if (
        (this.hasItemTypesMix && isNaN(this.set.currentItem)) ||
        (this.set.items[this.set.currentItem] &&
          this.set.items[this.set.currentItem].description["jewelleryType"] >
            0 &&
          !this.isJewelleryBut3dConfigurator() &&
          this.currentSet3d === false)
      ) {
        // do nothing
      } else {
        if ("caches" in window) {
          for (let index in this.$parent.$parent["hideImage"]) {
            if (index !== "set") {
              if (this.$parent.$parent["hideImage"][index] === true) {
                return true;
              }
            }
          }
        }
      }
      return false;
    },
    isVisualModeIcon: function () {
      if (!this.is3dViewerAllowed() || !("caches" in window)) {
        return false;
      }

      let isVisualModeIcon;

      /* Visual-Mode-Icon for Weddingrings */
      if (
        (this.hasItemTypesMix && isNaN(this.set.currentItem)) ||
        (this.set.items[this.set.currentItem] &&
          this.set.items[this.set.currentItem].description["jewelleryType"] >
            0) ||
        (this.set.items.length === 1 && this.onlyJewellery)
      ) {
        isVisualModeIcon = false;
      } else {
        isVisualModeIcon = this.set.currentItem !== "set";
      }

      /* Visual-Mode-Icon for Jewellery */
      if (!isVisualModeIcon) {
        if (this.isJewelleryBut3dConfigurator()) {
          // 123GOLD Chains
          isVisualModeIcon = true;
        }
      }
      if (!isVisualModeIcon) {
        if (
          this.set.items[this.set.currentItem] &&
          this.set.items[this.set.currentItem].description["jewelleryType"] > 0
        ) {
          let tmpSetId =
            this.set.items[this.set.currentItem].description["setId"];
          isVisualModeIcon = this.currentSet3d === tmpSetId || false;
        }
      }

      return isVisualModeIcon;
    },
    getWhiteForCSS: function () {
      return {
        "--image-white": "#" + this.whiteColor,
      };
    },
    getBlackForCSS: function () {
      return {
        "--image-black": "#" + this.blackColor,
      };
    },
    isJewelleryPics: function () {
      if (
        ((this.config.visualMode === "conf" && this.isDesktop()) ||
          this.config.visualMode === "show") &&
        this.set.currentItem >= 0 &&
        this.set.items[this.set.currentItem] &&
        this.set.items[this.set.currentItem].description &&
        this.set.items[this.set.currentItem].description.jewelleryType > 0
      ) {
        return true;
      }
      return false;
    },
    isBrandLogo: function () {
      if (
        (this.config.visualMode === "conf" ||
          this.config.visualMode === "show") &&
        this.set.currentItem >= 0 &&
        this.set.items[this.set.currentItem]
      ) {
        if (
          this.set.items[this.set.currentItem].description.jewelleryType > 0 ||
          this.set.items[this.set.currentItem].description.isBasicModel
        ) {
          return false;
        } else {
          return true;
        }
      }
      return false;
    },
    getBrandLogoSrc: function () {
      if (typeof SetData.getters.getCurrentItem == "object") {
        let brandId = SetData.getters.getCurrentItem.description.brandId;

        if (brandId == 1 || brandId == 11) {
          return this.appUrl + "/img/logos/acredo-white.svg";
        } else if (brandId == 2 || brandId == 12 || brandId == 24) {
          return this.appUrl + "/img/logos/steinberg-white.svg";
        } else if (brandId == 13) {
          return this.appUrl + "/img/logos/merii-white.svg";
        } else if (
          brandId == 3 ||
          brandId == 15 ||
          brandId == 18 ||
          brandId == 23
        ) {
          return this.appUrl + "/img/logos/eternal-touch-white.svg";
        } else if (brandId == 19) {
          return this.appUrl + "/img/logos/baldessarini-white.svg";
        }
      }
      return this.appUrl + "/img/logos/123gold-white.svg";
    },
    heartBg: function () {
      return this.isOnWishlist ? "#000000" : "none";
    },
    heartStroke: function () {
      return this.isOnWishlist
        ? "#000000"
        : this.currentItemBg === this.blackColor
        ? "#" + this.whiteColor
        : "#444444";
    },
    liElementWidth: function () {
      if (this.isValidSetId() && this.set.items.length > 1) {
        return Math.ceil(100 / (this.set.items.length + 3)) + "%";
      } else if (this.set.items.length == 1) {
        return "100%";
      } else {
        return Math.ceil(100 / (this.set.items.length + 2)) + "%";
      }
    },
    imageBgColor: function () {
      return !this.is3dViewerActive ? this.whiteColor : this.whiteColor;
    },
    hasItemTypesMix: function () {
      let hasItemTypesMix = false;
      let weddingRingFound = false;
      let basicModelFound = false;
      let jewelleryFound = false;
      let diamondFound = false;

      for (let itemIdx in this.set.items) {
        if (
          !isNaN(parseInt(this.set.items[itemIdx].description.jewelleryType))
        ) {
          if (
            0 !== parseInt(this.set.items[itemIdx].description.jewelleryType)
          ) {
            jewelleryFound = true;
            if (
              parseInt(this.set.items[itemIdx].description.jewelleryType) == 5
            ) {
              diamondFound = true;
            }
          } else {
            if (this.set.items[itemIdx].description.isBasicModel) {
              basicModelFound = true;
            } else if (
              parseInt(this.set.items[itemIdx].description.jewelleryType) === 0
            ) {
              weddingRingFound = true;
            }
          }
        }
      }

      if (
        (jewelleryFound === true && weddingRingFound === true) ||
        (jewelleryFound === true && basicModelFound === true) ||
        (weddingRingFound === true && basicModelFound === true) ||
        (weddingRingFound === false &&
          basicModelFound === false &&
          jewelleryFound === true &&
          this.set.items.length > 1) ||
        diamondFound === true
      ) {
        hasItemTypesMix = true;
      }
      return hasItemTypesMix;
    },
    onlyWeddingRings: function () {
      for (let itemIdx in this.set.items) {
        if (
          typeof this.set.items[itemIdx].description === "object" &&
          parseInt(this.set.items[itemIdx].description.jewelleryType) !== 0
        ) {
          return false;
        }
      }
      return true;
    },
    onlyJewellery: function () {
      for (let itemIdx in this.set.items) {
        if (
          typeof this.set.items[itemIdx].description === "object" &&
          parseInt(this.set.items[itemIdx].description.jewelleryType) < 1
        ) {
          return false;
        }
      }
      return true;
    },
    onlyBasicModels: function () {
      for (let itemIdx in this.set.items) {
        if (
          typeof this.set.items[itemIdx].description === "object" &&
          !this.set.items[itemIdx].description.isBasicModel
        ) {
          return false;
        }
      }
      return true;
    },
    isVariationInSet: function () {
      for (let itemIdx in this.set.items) {
        if (
          typeof this.set.items[itemIdx].description === "object" &&
          this.set.items[itemIdx].description.isVariation &&
          this.set.items[itemIdx].description.jewelleryType < 1
        ) {
          return true;
        }
      }
      return false;
    },
    addonList: function () {
      let addonList = [];

      if (
        (this.set.currentItem !== "overview" &&
          this.set.currentItem !== "all" &&
          this.set.currentItem !== "set") ||
        this.set.items.length === 1
      ) {
        if (
          Object.prototype.hasOwnProperty.call(
            this.set.items,
            this.set.currentItem
          )
        ) {
          let itemId = this.set.currentItem;
          if (typeof this.set.items[itemId].description.stones === "object") {
            if (
              typeof this.set.items[itemId].description.stones.groups ===
                "object" &&
              this.set.items[itemId].description.stones.groups.length > 0
            ) {
              for (let groupId in this.set.items[itemId].description.stones
                .groups) {
                if (
                  Object.prototype.hasOwnProperty.call(
                    this.set.items[itemId].description.stones.groups,
                    groupId
                  )
                ) {
                  for (let addonId in this.set.items[itemId].description.stones
                    .groups[groupId].addons) {
                    if (
                      Object.prototype.hasOwnProperty.call(
                        this.set.items[itemId].description.stones.groups[
                          groupId
                        ].addons,
                        addonId
                      )
                    ) {
                      addonList.push(
                        this.set.items[itemId].description.stones.groups[
                          groupId
                        ].addons[addonId].picture
                      );
                    }
                  }
                }
              }
            }
          }
        }
      }

      return addonList;
    },
    isSetImageAvailable() {
      return this.set.showSetImage === true;
    },
    isVariationSetPicture() {
      return (
        this.isVariationInSet &&
        ((!isNaN(this.set.currentItem) && this.isVariation()) ||
          (!this.hasItemTypesMix && isNaN(this.set.currentItem)))
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  .text-black {
    color: var(--image-black);
  }

  .text-white {
    color: var(--image-white);
  }

  .image-box {
    cursor: pointer;

    .image-list {
      background: var(--image-white);
      padding: 0;
    }
  }

  .imageviewer {
    margin-top: 1.5rem;
    width: 100%;
    position: relative;
    overflow: hidden;

    .image-list {
      div ul li {
        position: relative;
        height: 48em;

        img {
          position: sticky;
          top: 0;
          margin-top: -300px;
          max-width: inherit;
          max-height: inherit;
        }
      }
    }
  }

  #ShowPicture {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    background-color: var(--image-white);
    top: 0;
    left: 0;
    z-index: 1001;

    a {
      position: absolute;
      top: 2.75rem;
      right: 2rem;
      width: 2.4rem;
      height: 2.4rem;

      span {
        font-size: 3rem;
      }
    }

    img {
      margin: auto;
      width: 100%;
      max-width: 60rem;
    }
  }

  .image-bg-color {
    background-color: var(--image-black);
  }

  .image-bg-color-white {
    background-color: var(--image-white);
  }

  @media (max-width: 1199px) {
    .image-box.sticky {
      position: -webkit-sticky; /* Safari */
      position: sticky;
      top: 0;
      z-index: 100;
    }

    .image-box.fixed {
      position: fixed;
      border-bottom: 0.1rem solid $darkGrey;
      top: 0;
      z-index: 100;
    }
  }

  .image-list {
    position: relative;

    .variation-notification {
      padding: 0;
      margin: 0;

      p {
        color: var(--image-black);
        font-weight: bold;
        font-size: 0.9rem;
        letter-spacing: 0.1rem;
        border-top: 1px solid #cccccc;
        padding: 1rem 1rem 2.5rem 1rem;
        margin: 0;

        &.no-border {
          border-top: 1px solid #ffffff;
          padding-top: 1.1rem;
        }
      }

      &.images {
        margin-top: 32rem;
      }
    }

    #BrandLogo {
      margin-top: 0;
      display: flex;
      position: absolute;
      justify-content: center;
      z-index: 4;

      @media (min-width: 1200px) {
        margin-top: 3rem;
        margin-left: -1.5rem;
      }
    }

    #flag-icons {
      position: absolute;
      overflow: hidden;
      z-index: 1;
      background-color: transparent;
      top: 6rem;
      right: 0;


      .icon-flag {
        padding: 0 0.5rem;
        width: 10rem;
        float: right;
      }

      @media (min-width: 1200px) {
        top: 9rem;
        right: 1rem;
      }
    }

    .heart {
      position: absolute;
      overflow: hidden;
      top: 2rem;
      right: 2rem;
      width: 2.75rem;
      height: auto;
      cursor: pointer;
      z-index: 5;

      @media (min-width: 1200px) {
        top: 5rem;
      }
    }

    .magnifer {
      position: absolute;
      background-color: #ffffff;
      border-radius: 0.5rem;
      overflow: hidden;
      top: 6.25rem;
      right: 1.5rem;
      width: 3.2rem;
      height: auto;
      cursor: pointer;
      z-index: 5;
    }

    .visual-mode {
      position: absolute;
      overflow: hidden;
      top: 1.5rem;
      left: 1em;
      width: 6rem;
      height: auto;
      cursor: pointer;
      z-index: 5;

      @media (min-width: 992px) {
        top: 3.5rem;
        left: 2em;
      }
    }

    .rotate {
      display: none;
      position: absolute;
      top: 8em;
      right: 2em;
      width: 2em;
      height: auto;
      cursor: pointer;
    }

    .last-item-arrow,
    .next-item-arrow {
      display: none;
      position: absolute;
      width: 2em;
      text-align: center;
      opacity: 0.8;
      bottom: 0;
      height: 75%;
      padding-bottom: 13rem;
      cursor: pointer;
      z-index: 100;
    }

    .last-item-arrow {
      left: 1rem;
    }

    .next-item-arrow {
      right: 1rem;
    }

    .addon-list {
      position: absolute;
      top: 1rem;
      left: 1.5rem;
      width: 100%;
      padding: 0;
      margin: 0;
      overflow: visible;

      img.thumb,
      img.set-thumb {
        width: 3.5rem;
        height: 3.5rem;
      }

      @media (min-width: 768px) {
        img.thumb,
        img.set-thumb {
          width: 5rem;
          height: 5rem;
        }
      }

      .addon-thumb-0,
      .addon-thumb-1,
      .addon-thumb-2,
      .addon-thumb-3,
      .addon-thumb-4,
      .set-thumb-0,
      .set-thumb-1,
      .set-thumb-2,
      .set-thumb-3,
      .set-thumb-4 {
        position: absolute;
        left: 0;
        z-index: 110;
      }

      .addon-thumb-1,
      .set-thumb-1 {
        z-index: 109;
        left: 1em;
      }

      .addon-thumb-2,
      .set-thumb-2 {
        z-index: 108;
        left: 2em;
      }

      .addon-thumb-3,
      .set-thumb-3 {
        z-index: 107;
        left: 3em;
      }

      .addon-thumb-4,
      .set-thumb-4 {
        z-index: 106;
        left: 4em;
      }
    }
  }
}

.image-bdcolor {
  background-color: var(--image-white);
}

.image-list div {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  text-align: left;
  scroll-snap-type: x mandatory; /* Chrome Canary */
  scroll-snap-type: mandatory; /* Firefox */
  -ms-scroll-snap-type: mandatory; /* IE/Edge */
  -webkit-scroll-snap-type: mandatory; /* Safari */
  -webkit-scroll-snap-destination: 0% 0%;
  -webkit-overflow-scrolling: touch; /* important for iOS */
}

.image-list div ul {
  list-style: none;
  padding: 0;
  margin: 8rem 0 0 0;
  text-align: left;
  display: flex;

  &.vm-show,
  &.vm-conf {
    &.has-item-mix.without-side-menu {
      @media (min-width: 992px) {
        height: 60rem !important;
      }
    }
  }
}

.image-list div ul li {
  display: inline-block;
  scroll-snap-align: start; /* latest (Chrome 69+) */
  scroll-snap-coordinate: 0% 0%; /* older (Firefox/IE) */
  -webkit-scroll-snap-coordinate: 0% 0%; /* older (Safari) */
  text-align: center;
  margin-left: 0.1rem;
}

.image-list {
  div ul li {
    img {
      display: inline-block;
      max-width: 25em;
      max-height: 25em;
    }
  }
}

@media (max-width: 767px) {
  .image-box.sticky {
    .image-list div ul li img {
      max-width: 35rem;
      max-height: 35rem;
    }
  }
}

@media (max-width: 991px) {
  .image-list div ul li {
    width: 100vw;
  }

  .image-list div ul li img {
    width: 95vw;
  }
}

@media (min-width: 992px) {
  div.image-bdcolor .image-list div {
    width: 100%;
    scroll-snap-type: none;
    -ms-scroll-snap-type: none; /* IE/Edge */
    -webkit-scroll-snap-type: none; /* Safari */
    -webkit-scroll-snap-destination: 0% 0%;
    -webkit-overflow-scrolling: unset; /* important for iOS */
    overflow: hidden;
  }

  .image-list.image-wide div ul li img {
    max-width: 40em;
    max-height: 40em;
  }
}

@media (min-width: 375px) {
  .image-list div ul li img {
    display: inline-block;
    max-width: 30em;
    max-height: 30em;
  }
}

@media (min-width: 992px) {
  #app {
    #image-list {
      border-radius: 2.5rem;
    }

    .image-list {
      .addon-list {
        top: 2rem;
        left: 2.75rem;
      }

      .last-item-arrow {
        left: 2em;
      }

      .next-item-arrow {
        right: 2em;
      }
    }

    .image-box {
      .image-list {
        padding: 0 1.5rem 0 1.5rem;
      }
    }
  }
}
</style>
